/**
 * Centralized document direction and language setting
 * This ensures consistent RTL/LTR behavior across all language switching methods
 */

export const setDocumentDirection = (language: string): void => {
    console.log(`🌐 Setting document direction for language: ${language}`);
    
    if (language === 'fa') {
        document.documentElement.dir = 'rtl';
        document.documentElement.lang = 'fa';
        console.log('✅ Document set to RTL (Farsi)');
    } else {
        document.documentElement.dir = 'ltr';
        document.documentElement.lang = language;
        console.log(`✅ Document set to LTR (${language})`);
    }
};

/**
 * Get current document direction
 */
export const getDocumentDirection = (): 'rtl' | 'ltr' => {
    return document.documentElement.dir as 'rtl' | 'ltr' || 'ltr';
};

/**
 * Check if current language is RTL
 */
export const isRTLLanguage = (language: string): boolean => {
    return language === 'fa';
};

/**
 * Initialize document direction based on current language
 * This should be called on app startup
 */
export const initializeDocumentDirection = (language: string): void => {
    console.log(`🚀 Initializing document direction for: ${language}`);
    setDocumentDirection(language);
};
